export default __webpack_public_path__ + "static/media/AllerLightThin.0312903a.ttf";